import Modal from './Modal';
import { Workflow } from '../interfaces';
import { useTranslation } from 'react-i18next';
import HeroIcon from './HeroIcon';

interface Props {
  workflow: Workflow,
}

function WorkflowModalDetails(props: Props) {
  const { t } = useTranslation();

  const { workflow } = props;

  return (
    <Modal>
      <div className="w-full flex flex-row items-center">
        <div className="flex items-center justify-center w-10 h-10 mr-2 text-white rounded cursor-pointer" style={{ backgroundColor: workflow.color }}>
          <HeroIcon icon={workflow.icon} className="w-8 h-8" />
        </div>
        <div className='flex flex-col'>
          <div className="text-lg font-semibold text-gray-600">{workflow.name}</div>
          <div className='font-semibold text-gray-600 text-sm'>{workflow.owner?.fullName}&nbsp;<span className='text-gray-400'>({t("Workflow Owner")})</span></div>
        </div>
      </div>
      {workflow.description
        ? <div>{workflow.description}</div>
        : <div className='text-gray-400 italic'>{t("No description has been provided for this workflow.")}</div>
      }
    </Modal>
  );
}

export default WorkflowModalDetails;
